class PropriedadeParceiro {
  "id": Number = 0;
  "codigoFornecedorSap": Number = 0;
  "chave": String = "";
  "valor": String = "";
  "criadoEm": Date = new Date();
  "excluidoEm": Date = new Date();
  "d_E_L_E_T_E": boolean = false;
}
export default PropriedadeParceiro;
